import { axiosSFS, params } from '@/api/instance'

const fetchAirline = new Promise((resolve, reject) => {
  if (params.secret) {
    const url = axiosSFS.defaults.baseURL + '/airlines/' + params.secret
    axiosSFS.get(url).then((response) => {
      let res = response?.data
      if (res?.success) {
        resolve(res.data)
      }
    })
  }
})

const fetchAirlineShareDetail = new Promise((resolve, reject) => {
  if (params.secret) {
    const url = axiosSFS.defaults.baseURL + '/airlines/shareUpdate/' + params.secret
    axiosSFS.get(url).then((response) => {
      let res = response?.data
      if (res?.success) {
        resolve(res.data)
      }
    })
  }
})

const fetchPax = new Promise((resolve, reject) => {
  if (params.secret) {
    const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret
    axiosSFS.get(url).then((response) => {
      let res = response?.data
      if (res?.success) {
        resolve(res.data)
      }
    })
  }
})

const fetchPaxsGroup = new Promise((resolve, reject) => {
  if (params.secret) {
    const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/group'
    axiosSFS.get(url).then((response) => {
      let res = response?.data
      if (res?.success) {
        resolve(res.data)
      }
    })
  }
})

export { fetchAirline, fetchPax, fetchPaxsGroup, fetchAirlineShareDetail }
